// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"247":"ff6a175d","641":"ef2480a7"}[chunkId] + ".js";
};